module.exports = __webpack_public_path__ + "img/progress_042.1fba5239.png";